import React from "react"
import { LayoutInlineMedia } from "trimble-terra"
import RichTextConnector from "../../../components/RichText/RichTextConnector"
import { formatCommonComponentFields } from "./formatLayoutFunctions"
import { formatFocusedImage } from "../formatBaseMolecules";
import formatPageLinks from "../formatPageLinks"

const FormatAndRenderLayoutInlineMedia = ({
  data,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId,
}) => {
  const formattedComponentData = formatCommonComponentFields(
    data,
    locale,
    siteIdentifier,
    homepageSlug,
    currentSpaceId
  )

  const processMedia = media => {
    if(media?.__typename === "ContentfulImage") {
      return {
        ...formatFocusedImage(media),
        alt: media?.altText,
        type: "image",
      }
    } else if (media?.__typename === "ContentfulBynderAsset") {

      const transformedMedia = {
        image: { file: { url: media?.bynderAssetReference?.[0]?.src } },
        altText: media?.altText,
      }
      return {
        ...formatFocusedImage(transformedMedia),
        alt: media?.altText,
        type: "image",
      }
    } else {
      // adjusting the format of the media object so we can use formatFocusedImage below
      const transformedMedia = {
        ...media,
        ...(media?.image ? {
          ...media?.image
          } : {
            ...media?.videoThumbnail
          })
      }
      const transformedMediaSection = {
        ...formatFocusedImage(transformedMedia),
        alt: media?.altText,
        videoURL: media?.videoUrl,
        type: media?.__typename === "ContentfulImage" ? "image" : "video",
      }
      return transformedMediaSection
    }
  }

  const formattedLayoutInlineMediaData = {
    ...formattedComponentData,
    inlineMediaPanels: formattedComponentData?.mediaSections?.map(
      mediaSection => {
        return {
          ...mediaSection,
          publicTitle: mediaSection?.title,
          description:
            (mediaSection?.description && (
              <RichTextConnector
                data={{ content: mediaSection?.description }}
              />
            )) ||
            null,
          alignment:
            mediaSection?.alignment &&
            mediaSection?.alignment
              .toLowerCase()
              .split(" ")
              .map((word, index) =>
                index === 0
                  ? word
                  : word.charAt(0).toUpperCase() + word.slice(1)
              )
              .join(""),
          media: mediaSection?.media?.map(media => {
            return processMedia(media)
          }),
          buttons: mediaSection?.buttons?.map((button, index) => {
            const formattedButton = formatPageLinks(
              button,
              locale,
              button?.dynamicPageReference?.__typename,
              homepageSlug,
              currentSpaceId,
              siteIdentifier
            )
            return {
              ...formattedButton,
              label: formattedButton?.text,
              destination:
                formattedButton?.linkUrl || formattedButton?.destination,
              primary: button.isPrimary ? true : false,
              size: "large",
            }
          }),
        }
      }
    ),
    variant:
      formattedComponentData?.variant &&
      formattedComponentData?.variant?.toLowerCase(),
    buttons: formattedComponentData?.buttons?.map((button, index) => {
      const formattedButton = formatPageLinks(
        button,
        locale,
        button?.dynamicPageReference?.__typename,
        homepageSlug,
        currentSpaceId,
        siteIdentifier
      )
      return {
        label: formattedButton?.text,
        destination: formattedButton?.linkUrl || formattedButton?.destination,
        primary: button.isPrimary ? true : false,
      }
    }),
  }

  return (
    <LayoutInlineMedia {...formattedLayoutInlineMediaData} isWrapped={true} />
  )
}

export default FormatAndRenderLayoutInlineMedia
